var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"height":"100vh"},attrs:{"src":'//cdn.yxvzb.com/WEB/static-html/ysh_logoff_agreement.html?t=' +
      Date.now(),"frameborder":"0","width":"100%"}})}
var staticRenderFns = []
export { render, staticRenderFns }